import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../Product/Auth/AuthContext";
import { chatSocket, connectChatSocket } from "../Product/socket";

export default function GlobalChatNotifier() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;

    // Connect chat socket on login
    connectChatSocket();

    const userId = (user.id || user._id || "").toString();

    const handleNewMessage = (msg) => {
      // Don't show toast for messages sent by self
      const senderId = (msg.senderId || "").toString();
      if (senderId === userId) return;

      // Don't show toast if user is currently on the active chat page
      if (location.pathname.includes("/chat")) return;

      const senderName = msg.senderName || "Mestri / Vendor";
      const messageText = msg.text || (msg.attachments?.length ? "Sent an attachment" : "New message");

      toast.info(
        <div style={{ cursor: "pointer" }}>
          <strong>💬 New Message from {senderName}</strong>
          <p style={{ margin: "4px 0 0 0", fontSize: "0.85rem", opacity: 0.9 }}>
            {messageText.length > 50 ? messageText.slice(0, 50) + "..." : messageText}
          </p>
        </div>,
        {
          position: "bottom-right",
          autoClose: 5000,
          onClick: () => {
            navigate("/chat");
          },
        }
      );
    };

    chatSocket.on("new_message", handleNewMessage);

    return () => {
      chatSocket.off("new_message", handleNewMessage);
    };
  }, [user, location.pathname, navigate]);

  return null;
}
